import Header from "../Header/Header";
import Invoice from "./Invoice";

const InvoiceContent = () =>{
    return (
        <section className="extract-pdf-mainsection invoice-content-pdf">
                <Header/>
                <Invoice/>
        </section>
    )
}
export default InvoiceContent;
